import React from 'react';
import core from '@gin-betting/core';

import messages from '../../messages';
import BetslipModal from '../BetslipModal';
import useRefillBalanceModal from './useRefillBalanceModal';

interface Props {
    betslipBetId: string;
}
const {
    utils: { getCurrency },
} = core;

const RefillBalanceModal: React.FC<Props> = ({ betslipBetId }) => {
    const {
        isModalOpen,
        handleCancel,
        missingBalance,
        handleRefillBalance,
        placeBet,
        actualBalance,
        isStakeBtn,
    } = useRefillBalanceModal({
        betslipBetId,
    });

    if (!isModalOpen) return null;

    const { currencySymbol } = getCurrency();

    return (
        <BetslipModal
            handleSubmit={handleRefillBalance}
            handleCancel={handleCancel}
            handleClick={placeBet}
            balance={`${missingBalance} ${currencySymbol}`}
            title={messages.refillBalanceTitle}
            cancelTextBtn={messages.declineButton}
            subTextBtn={messages.placeBetStake}
            message={messages.refillBalanceMessage}
            submitTextBtn={messages.refill}
            stake={`${currencySymbol} ${actualBalance}`}
            isStakeBtn={isStakeBtn}
        />
    );
};

export default RefillBalanceModal;
